<template>
  <el-date-picker v-bind="$attrs"
                  v-on="$listeners"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  :range-separator="$t('datePicker.to')"
                  :start-placeholder="$t('datePicker.startPlaceholder')"
                  :end-placeholder="$t('datePicker.endPlaceholder')"
                  :picker-options="pickerOptions"
  />
</template>
<script>
  import { DatePicker } from 'element-ui'
  import { dateRanges, getDateRange } from 'src/config/dateUtils'

  export default {
    inheritAttrs: false,
    components: {
      [DatePicker.name]: DatePicker,
    },
    computed: {
      pickerOptions () {
        return {
          shortcuts: [
            {
              text: this.$t('datePicker.shortcuts.lastMonth'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.MONTH))
              }
            },
            {
              text: this.$t('datePicker.shortcuts.lastThreeMonths'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.THREE_MONTHS))
              }
            },
            {
              text: this.$t('datePicker.shortcuts.lastSixMonths'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.SIX_MONTHS))
              }
            },
            {
              text: this.$t('datePicker.shortcuts.lastYear'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.YEAR))
              }
            }
          ]
        }
      }
    }
  }
</script>
<style>
</style>
